import { render } from "./TextLabel.vue?vue&type=template&id=79bfecbb&scoped=true&ts=true"
import script from "./TextLabel.vue?vue&type=script&lang=ts"
export * from "./TextLabel.vue?vue&type=script&lang=ts"

import "./TextLabel.vue?vue&type=style&index=0&id=79bfecbb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79bfecbb"]])

export default __exports__